import { type JSX, useState } from "react"
import { saveWorkspace } from "./api"

// The workspace name at the top of the rail; click to rename in place.
export function WorkspaceName({
  name,
  updateUrl,
  onChange,
}: {
  name: string
  updateUrl: string
  onChange: (value: string) => void
}): JSX.Element {
  const [editing, setEditing] = useState(false)
  const [draft, setDraft] = useState(name)

  function startEditing(): void {
    setDraft(name)
    setEditing(true)
  }

  // Blank names are rejected server-side, so treat an empty field as a cancel
  // rather than showing an error in a one-line input.
  async function commit(): Promise<void> {
    setEditing(false)

    const next = draft.trim()
    if (!next || next === name) return

    if (await saveWorkspace(updateUrl, { name: next })) {
      onChange(next)
    }
  }

  if (!editing) {
    return (
      <button type="button" className="workspace__rail-title" onClick={startEditing} title="Click to rename">
        {name}
      </button>
    )
  }

  return (
    <input
      type="text"
      className="workspace__rail-title-input"
      aria-label="Workspace name"
      value={draft}
      maxLength={300}
      autoFocus
      onChange={(event) => setDraft(event.target.value)}
      onBlur={() => void commit()}
      onKeyDown={(event) => {
        if (event.key === "Enter") {
          event.preventDefault()
          void commit()
        } else if (event.key === "Escape") {
          event.preventDefault()
          setEditing(false)
        }
      }}
    />
  )
}
